module.exports = __webpack_public_path__ + "static/logo_white-52a99dcc847d83592c6b47dca0767fa5.png";